import { makeApi } from "./callApi";
import axios from "axios";
export class AppApi {
  static async getPreSignedUploadUrl(fileEntityType, fileExtension) {
    const response = await makeApi(
      `/pre-signed-url/upload?fileEntityType=${fileEntityType}&fileExtension=${fileExtension}`,
      "GET"
    );
    return response.data;
  }

  static async uploadFile(fileEntityType, file) {
    const { filePath, uploadUrl } = await AppApi.getPreSignedUploadUrl(
      fileEntityType,
      file.type.split("/")[1]
    );
    await axios.put(uploadUrl, file, {
      headers: {
        "Content-Type": file.type,
      },
    });
    return { filePath };
  }
}
